//Constants needed to connect api services
export const apiEndPoint = 'https://testing-despacho-api.hmhsistemas.com.mx/';
export const base_url = `/#/`;
export const userRoles = {
  ADMINISTRADOR: 'Administrador',
  AUDITOR: 'Auditor',
  OPERADOR: 'Operador',
  CLIENTE: 'Cliente',
};
export const MESSAGES_SERVICES = {
  COMMENTS: 'comments',
  OBSERVATIONS: 'observations',
  RECOMENDATIONS: 'recomendations',
  CONCLUSIONS: 'conclusions',
};
export const serviceName = {
  CONTABILIDAD: 'Contabilidad',
  AUDITORIA: 'Auditoria',
  NOMINA: 'Nomina',
};
export default {
  apiEndPoint,
  base_url,
  userRoles,
  MESSAGES_SERVICES,
  serviceName,
};
